import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getUnprocessedI9Forms } from 'api/everify/user_w2'
import { userUnprocessedI9Forms } from './keys'

interface FilterParams {
  market?: string
  mailingState?: string
}

export const useUnprocessedI9Forms = (params?: FilterParams) => {
  return useQuery({
    queryKey: [...userUnprocessedI9Forms, params],
    queryFn: () => getUnprocessedI9Forms(params),
  })
}

export const useInvalidateUnprocessedI9Forms = () => {
  const queryClient = useQueryClient()

  return function invalidateUnprocessedI9Forms() {
    queryClient.invalidateQueries({
      queryKey: userUnprocessedI9Forms,
    })
  }
}
